import { Divider, Select } from "antd";
import Title from "antd/es/typography/Title";
import { useFormikContext } from "formik";
import { ExecuteReportValues, AdaptedValues } from "shared/types";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Colors } from "shared/themes";

interface OrderTypeFilterProps {
  adaptedOrders: AdaptedValues[];
  selectedOrderId: number | null;
  onOrderChange: (value: number) => void;
  onOrderSearch: (value: string) => void;
  isLoadingOrders: boolean;
}

const OrderTypeFilter: FC<OrderTypeFilterProps> = ({
  adaptedOrders,
  selectedOrderId,
  onOrderChange,
  onOrderSearch,
  isLoadingOrders,
}) => {
  const { t } = useTranslation("", { keyPrefix: "executeReports" });

  const { setFieldValue } = useFormikContext<ExecuteReportValues>();

  const expandOnOrderChange = (value: number) => {
    onOrderChange(value);
    setFieldValue("order_id", value);
  };

  return (
    <>
      <Divider className="my-1.5" style={{ background: Colors.blue.primary }} />

      <div className="flex flex-col gap-y-0.5">
        <div className="flex gap-x-2">
          <Title level={5} className="whitespace-nowrap !m-0 !text-start">
            {t("selectOrder")}
          </Title>
          {" - "}
          <Select
            loading={isLoadingOrders}
            value={selectedOrderId}
            placeholder={t("selectOrder")}
            options={adaptedOrders}
            onChange={expandOnOrderChange}
            onSearch={onOrderSearch}
            className="w-auto"
            size="small"
            showSearch
            filterOption={false}
          />
        </div>
        <span className="text-[10px] leading-tight text-gray-400">
          * {t("orderSearchHint")}
        </span>
      </div>
      <Divider className="my-1.5" style={{ background: Colors.blue.primary }} />
    </>
  );
};

export { OrderTypeFilter };
